export default __webpack_public_path__ + "./image/18da52ff08fc52b13faa0df770b41d9c.png";